import { gql } from '@apollo/client';

export const OBJECTIVE_CRITERIA_TYPES_QUERY = gql`
    query {
        objectiveCriterionTypes {
            edges {
                node {
                    id
                    key
                    name
                    description
                    kafkaTopic
                    targetCountRequired
                    targetValueRequired
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;
